<div
  #bannerHost
  class="banner-transversal-host"
  role="region"
  aria-label="Banner transversal"
></div>
